import { format, parse, add } from "date-fns";
import { Trans, useTranslation } from 'react-i18next';


function formatDateTime(param) {
    //  console.log("formatDateTime ", param);
    if (!param)
        return null;

    let formatStr = "dd.MM.yyyy HH:mm";
    let formattedDate = format(new Date(param), formatStr);

    return formattedDate;
}
function formatDate(param) {
    // console.log("formatDate", param)
    if (!param || param === null)
        return null;
    let formatStr = "dd.MM.yyyy";
    let formattedDate = format(new Date(param), formatStr);

    return formattedDate;
}

function formatTimestamp(param, onAction) {
    if (!param)
        return null;

    let formatStr = "dd.MM.yyyy HH:mm";
    let formattedDate = format(new Date(param), formatStr);
    onAction(formattedDate);

}


function formatApiDate(param) {
    // console.log("formatDate", param)
    if (!param || param === null)
        return null;
    let formatStr = "yyyyMMdd";
    let formattedDate = format(param, formatStr);

    return formattedDate;
}

function currencyFormat(num) {
    try {
        if (num === null)
            return null;
        // console.log("currencyFormat",num)

        let prefix = '$';

        return prefix + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    } catch {
        return null;
    }
}
function currencyFeeFormat(num) {
    try {
        if (num === null)
            return null;

        let prefix = '+ $';
        if (num < 0) {
            num = num * -1;
            prefix = '- $'
        }
        return prefix + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    } catch {
        return null;
    }
}
function decimalFormat(num) {
    try {

        if (num === null)
            return null;
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    } catch {
        return null;
    }
}


function runOnJSValueOnAction(param, onAction) {
    onAction(param);
}

function formatUserName(textValue) {
    return textValue.toLowerCase();
}

function startsWith(str, word) {
    try {
        return str.indexOf(word, 0) === 0;
    } catch {
        return false;
    }
}


function endsWith(str, word) {
    return str.indexOf(word, str.length - word.length) !== -1;
}

const emailValidation = (param) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!param || regex.test(param) === false) {
        return false;
    }
    return true;
}
const currentYear = new Date().getFullYear();


function plusDay(paramDate, days) {

    return add(paramDate, { days: days });

}

function parseFilterDate(param) {
    if (!param || param === null)
        return null;
    let formatStr = "dd-MM-yyyy";
    let parseDate = parse(param, formatStr, new Date());

    return parseDate;
}
function elapsedDay(startDate, endDate) {
    try {
        console.log("elapsedDay2: ", startDate, endDate);
        let elapsed = parseFilterDate(endDate) - parseFilterDate(startDate);
        return Math.floor(elapsed / (1000 * 60 * 60 * 24));
    } catch {
        console.log("elapsedDay: ", startDate, endDate);
        let elapsed = new Date(endDate) - new Date(startDate);
        return Math.floor(elapsed / (1000 * 60 * 60 * 24));

    }
}

const utils = {
    formatDate, formatDateTime, formatTimestamp, runOnJSValueOnAction, formatApiDate, currencyFormat, decimalFormat,
    formatUserName, currencyFeeFormat, startsWith, endsWith, emailValidation,currentYear,plusDay,elapsedDay
};
export default utils;